import React, { Component } from "react";
// import Header from './Header.js'
// import Footer from './Footer';
import ProjPeopleContent from "./ProjPeopleContent";
/**
 * Research Fellows Component
 */
const data = {
  header: ["S. No. ", "Project", "Research Fellow"],
  rows: {
    row1:  [  "1",      "Spatial Flood Early Warning System",  "Ms Peesapati Radha Manasa (RS & GIS)", ],
    row2:  ["", "", "Shri Devaraj R (RS & GIS)"],
    row3:  ["", "", "Ms K Sindhu SRF (RS & GIS) (till 26-Apr-2021)"],
    row4:  ["", "", "Ms Shraddha Madhav Moon (WR) (till 11-Oct-2019)"],
    row5:  [      "2",      "Regional Evaporative Flux Monitoring System", "Ms Nalnajisa K A (RS & GIS)", ],
    row6:  ["", "",  "Ms P Krishna Bhargavi (WR) (till 13-Mar-2020)"],
    row7:  ["", "", "Shri Nagendra Jaiganesh (RS & GIS) (till 17-Oct-2018)"],
    row8:  [      "3",      "Glacial Lake Outburst Flood (GLOF) Risk Assessment",     "Shri Pamir Roy (RS & GIS)" ,  ],
    row9:  ["", "", "Smt. Abina R (RS & GIS)"],
    row10:  ["", "", "Smt. Maheshwari Ruhi Akilesh (RS & GIS) (till 30-Nov-2022)"],
    row11:  ["", "", "Smt. Sweta (WR) (till 13-Oct-2022)"],
    row12: [      "4",      "Spatial Snowmelt Runoff Estimation",   "Ms Anabathula Rajeswari (WR)"],
    row13:  ["", "", "Ms V Madhavi Supriya (RS & GIS) (till 10-Aug-2020)"],

    row14: [ "5",      "Operational Web-based National Hydrological Modelling System",  "Ms Bukya Sreelaxmi (RS & GIS)",],   
    row15: ["", "",  "Shri S Anantha Krishnan (WR) (till 01-Mar-2019)", ],

    row16: ["6",      "Satellite Data Based Inputs for Irrigation Scheduling",   "Shri Sanjay Mallya (RS & GIS)"   ,    ],
    row17: ["", "","Shri Shobhan Mishra (WR) (till 29-Jan-2021)" ],


    row18: [ "7",      "Operational Hydrological Drought Services",   "Ms Channa Satya Geetha Vimala (RS & GIS)"   ,    ],
    row19: ["", "","Shri K. Sai Santosh (WR) (till 30-Sep-2021)" ],
  },
  
  
  // {
  //   row1: [
  //     "1",
  //     "Spatial Flood Early Warning System",
  //     "Ms. Shraddha Madhav Moon JRF (WR) (till 11-Oct-2019)",
  //   ],
  //   row2: ["", "", "Ms. K Sindhu SRF (RS & GIS) (till 26-Apr-2021)"],
  //   row3: [
  //     "2",
  //     "Regional Evaporative Flux Monitoring System",
  //     "Ms. P Krishna Bhargavi JRF (WR) (till 13-Mar-2020)",
  //   ],
  //   row4: ["", "", "Sri. Nagendra Jaiganesh JRF (RS & GIS) (till 17-Oct-2018)"],
  //   row5: [
  //     "3",
  //     "Glacial Lake Outburst Flood (GLOF) Risk Assessment",
  //     "Smt. Sweta Shettenor SRF (WR)",
  //   ],
  //   row6: ["", "", "Smt. Maheshwari Ruhi Akilesh SRF (RS & GIS)"],
  //   row7: [
  //     "4",
  //     "Spatial Snowmelt Runoff Estimation",
  //     "Ms. V Madhavi Supriya SRF (RS & GIS)",
  //   ],
  //   row8: [
  //     "5",
  //     "Operational Web-based National Hydrological Modelling System",
  //     "Sri. S Anantha Krishnan JRF (WR) (till 01-Mar-2019)",
  //   ],
  //   row9: [
  //     "6",
  //     "Satellite data based inputs for Irrigation Scheduling",
  //     "Sri. Shobhan Mishra SRF (WR) (till 29-Jan-2021)",
  //   ],
  //   row10: [
  //     "7",
  //     "Operational hydrological drought services",
  //     "Sri. K. Sai Santosh SRF (WR)",
  //   ],
  //   // row11:["","","Sri. Debasish Dutta JRF (WR)"],
  // },
};
export default class ResearchFellows extends Component {
  render() {
    return (
      <div
        style={{
          padding: "15px",
          boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
          overflowY: "auto",
        }}
        className="card"
      >
        <h3 style={{ textAlign: "center", color: "#002171" }}>
          Research Fellows
        </h3>
        {/* <h5 style={{textAlign:"right",color: "#002171",margin:"0px",padding:"0px"}}> *Note: Red color denotes Ex-Employees</h5> */}
        <div className="card-body" style={{width:"70vw",margin:"0 auto"}} >
          {/* <p style={{ textAlign: "right" }}>Note : </p> */}
          <ProjPeopleContent data={data} width="50%" />
        </div>
      </div>
    );
  }
}
